import { swrFetcher } from 'src/utils/http-client/swr';

export const GET_CATEGORIES_KEY = 'categories';
const GET_CATEGORIES = /* GraphQL */ `
    query {
        categories {
            name
            order
            categoryId
        }
    }
`;

export function getCategories() {
    return swrFetcher(GET_CATEGORIES);
}

export const GET_MODELS_KEY = 'models';
const GET_MODELS = /* GraphQL */ `
    query {
        categories {
            name
            order
            categoryId
        }
        models {
            backendRepo
            categoryId
            category {
                name
                order
                categoryId
            }
            description
            designUrl
            examples
            features
            frontendRepo
            keywords
            modelId
            name
            prototypeUrl
            storageUrl
            summary
            thumbnail
            version
        }
    }
`;

export function getModels() {
    return swrFetcher(GET_MODELS);
}

export const GET_MODEL_BY_ID_KEY = 'model';
const GET_MODEL_BY_ID = /* GraphQL */ `
    query GetModelById($modelId: ID) {
        model(modelId: $modelId) {
            backendRepo
            categoryId
            description
            designUrl
            examples
            features
            frontendRepo
            keywords
            modelId
            name
            prototypeUrl
            storageUrl
            summary
            thumbnail
            version
        }
    }
`;

export function getModelById(modelId: number) {
    return swrFetcher(GET_MODEL_BY_ID, { modelId });
}

const GET_BASE_MODELS = /* GraphQL */ `
    query {
        categories {
            name
            order
            categoryId
        }
        models {
            categoryId
            modelId
            name
        }
    }
`;

export async function getBaseModels() {
    try {
        const models = await swrFetcher(GET_BASE_MODELS);
        return models;
    } catch (err) {
        return []
    }
}

const GET_BASE_AVAILABLE_MODEL_IDS = /* GraphQL */ `
    query {
        models {
            modelId
        }
    }
`;

export function getBaseAvailableModelIds() {
    return swrFetcher(GET_BASE_AVAILABLE_MODEL_IDS);
}
